@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.headerWrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 16px 16px;
}

.titleAndButtonRow {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.title {
  @include typography-v2-title-base;
  color: var(--text-default);
}

.buttonContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.styledButtonGroup {
  border: 1px solid var(--border-soft);
  @include border-radius-r3;

  [data-button-group] {
    padding: 4px;
  }

  [data-button-group-item] {
    @include border-radius-r2;
    @include typography-v2-body-sm;
    height: 24px;
    padding: 0;
  }
}

.tooltipLabel {
  white-space: nowrap;
}
